// Copyright (c) 2024 IOTA Stiftung
// SPDX-License-Identifier: Apache-2.0

export enum ObjectFilterValue {
    Input = 'InputObject',
    Changed = 'ChangedObject',
}
